import { Link } from '@tanstack/react-router'
import type { useOccasionNavModel } from '@/components/occasion/occasion-page/components/occasion-nav/occasion-nav.model'

type OccasionNavViewProps = ReturnType<typeof useOccasionNavModel>

export function OccasionNavView({ occasions }: OccasionNavViewProps) {
  return (
    <nav className="fz-occasion-nav" aria-label="Outras ocasiões">
      {occasions.map((occasion) => (
        <Link
          key={occasion.id}
          to="/ocasioes/$ocasiao"
          params={{ ocasiao: occasion.id }}
          className="fz-occasion-nav__pill"
        >
          {occasion.title}
        </Link>
      ))}
    </nav>
  )
}
